import { useCallback, useState } from 'react';
import { useIsMobile } from '@/hooks/use-mobile';

export const useSearchDialogState = () => {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);

  const openDialog = useCallback(() => {
    if (isMobile) {
      setIsFullScreen(true);
    }

    setOpen(true);
  }, [isMobile]);

  const closeDialog = useCallback(() => {
    setOpen(false);
  }, []);

  const toggleFullScreen = useCallback(() => {
    if (isMobile) {
      return;
    }

    setIsFullScreen(previousState => !previousState);
  }, [isMobile]);

  return {
    closeDialog,
    isFullScreen: isMobile || isFullScreen,
    isMobile,
    open,
    openDialog,
    setOpen,
    toggleFullScreen
  };
};
